import { SaveAddressModel, SaveCriteriaModel, SaveSignatureModel } from './../../module/signature/model/signature.model';
import { TarificationModel, EvaluationModel } from 'src/app/module/guarantee/model/guarantee.model';

export interface ContactDetails {
    FirstName: string;
    Name: string;
    LastName: string;
    EmailAddress: string;
    Telephone: string;
    PostalCode: string;
    DateofBirth: string;
    StreetName: string;
    StreetNumber: string;
    BoxNumber: string;
}

export interface ContactDetailsResponseModel {
    FirstName: string;
    Name: string;
    LastName: string;
    emailaddress: string;
    PostalCode: string;
    telephone: string;
    ContactPreferance: string;
    accountnumber: string;
    DateofBirth: string;
    StreetName: string;
    StreetNumber: string;
    BoxNumber: string;
}

export class Account {
    FirstName: string;
    LastName: string;
    emailaddress: string;
    telephone: string;
    accountnumber: string;
    PostalCode: string;
    DateofBirth: string;
    'Help_Reason': string;
    'Contact_Preference': string;
    OptionSalesContact: boolean;
    'ContactChanged': boolean;
}

export class Simulation {
    Version: number;
    Channel: string;
    SimulationType: string;
    SimulationStage: string;
    'Simulation_Reservation_Reason': string;
    Status: string;
    StartDate: string;
    EndDate: string;
    CurrentPage: string;
    TrackActivity: string;
    SimulationToken: string;
}

export class Answer {
    ChoiceId: number;
    AnswerKey: string;
    AnswerText: string;
    AnsweredDateTime: string;
}

export class Question {
    QuestionId: number;
    QuestionKey: string;
    QuestionText: string;
    Answers: Answer[];
}

export class QuestionGroup {
    QuestionGroupId: number;
    QuestionGroupKey: string;
    QuestionGroupText: string;
    Questions: Question[];
}

export class Section {
    SectionId: number;
    SectionKey: string;
    SectionText: string;
    QuestionGroups: QuestionGroup[];
}

export class SimulationInput {
    Sections: Section[];
}

export class SaveRequestModel {
    Language: string;
    Operation: string;
    GenerateSimulation: boolean;
    SendSimulationMail: boolean;
    SimulationDocumentum: boolean;
    Account: Account;
    Simulation: Simulation;
    SimulationInput: SimulationInput;
    Tarification: TarificationModel;
    Evaluation: EvaluationModel;
    Address: SaveAddressModel;
    Criteria: SaveCriteriaModel;
    Signature: SaveSignatureModel;
}
